import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import {CountryApiModel} from "../../common/country/models/country-api-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {CompetitorApiModel} from "../../common/competitor/models/competitor-api-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {AthleteApiModel} from "../../common/athlete/athlete-api-model";

export class SearchResponseApiModel extends BaseApiResponseModel {
  sports: Array<SportApiModel>;
  countries: Array<CountryApiModel>;
  competitions: Array<CompetitionApiModel>;
  competitors: Array<CompetitorApiModel>;
  athletes: Array<AthleteApiModel>;

  constructor(model: SearchResponseApiModel, request) {
    super(model, request);

    this.sports = model.sports;
    this.countries = model.countries;
    this.competitions = model.competitions;
    this.competitors = model.competitors;
    this.athletes = model.athletes;
  }
}
